import { render, staticRenderFns } from "./Agenda_Component.vue?vue&type=template&id=5e143ac7"
import script from "./Agenda_Component.vue?vue&type=script&lang=js"
export * from "./Agenda_Component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports